module.exports = __webpack_public_path__ + "static/img/emoji_7.e5c41858.png";